import {
  component_styles_default,
  r
} from "./chunk.3PRAXUFA.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.XGXDQT2J.js
var tab_panel_styles_default = r` ${component_styles_default} :host { --padding: 0; display: block; } .tab-panel { border: solid 1px transparent; padding: var(--padding); } `;

export {
  tab_panel_styles_default
};
